// Tiny i18n: t(key, params). All user-facing strings go through here (docs/08 §10).
// Strings may carry keyword markup: [value]…[/], [mult]…[/], [xmult]…[/], [luck]…[/], [hunger]…[/].
import en from './en.json';
import enAct2 from './en.act2.json';
import enAct3 from './en.act3.json';
import enMeta from './en.meta.json';

type Dict = Record<string, string>;
/** English text, split by act (and the meta features) so no file grows unwieldy. */
export const EN: Dict = { ...(en as Dict), ...(enAct2 as Dict), ...(enAct3 as Dict), ...(enMeta as Dict) };
const DICTS: Record<string, Dict> = { en: EN };
let current: Dict = DICTS.en!;
const missing = new Set<string>();

export function setLocale(locale: string): void {
  current = DICTS[locale] ?? DICTS.en!;
}

export function hasKey(key: string): boolean {
  return key in current;
}

export function t(key: string, params?: Record<string, string | number>): string {
  let s = current[key];
  if (s === undefined) {
    if (!missing.has(key)) {
      missing.add(key);
      console.warn(`i18n: missing key ${key}`);
    }
    return key;
  }
  if (params) s = s.replace(/\{(\w+)\}/g, (m, p: string) => (p in params ? String(params[p]) : m));
  return s;
}

export const ALL_KEYS = (): string[] => Object.keys(DICTS.en!);

export type KeywordKind = 'value' | 'mult' | 'xmult' | 'luck' | 'hunger' | 'doom' | 'bad' | 'good';
export interface TextSpan {
  text: string;
  kind?: KeywordKind;
}

/** Split keyword markup into spans for rendering. */
export function spans(s: string): TextSpan[] {
  const out: TextSpan[] = [];
  const re = /\[(value|mult|xmult|luck|hunger|doom|bad|good)\](.*?)\[\/\]/g;
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(s))) {
    if (m.index > last) out.push({ text: s.slice(last, m.index) });
    out.push({ text: m[2]!, kind: m[1] as KeywordKind });
    last = m.index + m[0].length;
  }
  if (last < s.length) out.push({ text: s.slice(last) });
  return out;
}

export function plain(s: string): string {
  return spans(s)
    .map((x) => x.text)
    .join('');
}
